import React from 'react';
import { formatStatusLabel } from '../api/ticketsApi';

function TicketStatusBadge({ status }) {
  const normalized = (status || '').toLowerCase().replace(/\s+/g, '_');
  return (
    <span className={`tk-pill tk-pill-status-${normalized || 'closed'}`}>
      {formatStatusLabel(normalized)}
    </span>
  );
}

export default TicketStatusBadge;
